import styled from "styled-components/native";

const GlobalStyle = styled.View`
	background-color: #f0f2f5;
	margin: 0;
	padding: 0;
	width: 100%;
	height: 100%;

	display: flex;

	flex-direction: column;
`;

export default GlobalStyle;
